import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "amount": {
      "column": null,
      "name": "amount",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "quantity": {
      "column": {
        "default": null,
        "name": "quantity",
        "null": true,
        "type": "integer"
      },
      "name": "quantity",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_invoice_id": {
      "column": {
        "default": null,
        "name": "stripe_invoice_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_invoice_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_plan_id": {
      "column": {
        "default": null,
        "name": "stripe_plan_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_plan_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeInvoiceItem",
  "collectionKey": "stripe_invoice_items",
  "collectionName": "stripe_invoice_items",
  "i18nKey": "stripe_invoice_item",
  "camelizedLower": "stripeInvoiceItem",
  "name": "StripeInvoiceItem",
  "nameDasherized": "stripe-invoice-item",
  "pluralName": "stripe_invoice_items",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_invoice_id",
      "name": "stripe_invoice",
      "macro": "belongs_to",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plan",
      "macro": "belongs_to",
      "resource_name": "StripePlan",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription",
      "macro": "belongs_to",
      "resource_name": "StripeSubscription",
      "through": null
    },
    {
      "className": "StripeSubscriptionItem",
      "collectionName": "stripe_subscription_items",
      "foreignKey": "stripe_subscription_item_id",
      "name": "stripe_subscription_item",
      "macro": "belongs_to",
      "resource_name": "StripeSubscriptionItem",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount_cents",
      "column": {
        "default": null,
        "name": "amount_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_currency",
      "column": {
        "default": null,
        "name": "amount_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "datetime",
      "column": {
        "default": null,
        "name": "datetime",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "discountable",
      "column": {
        "default": null,
        "name": "discountable",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "period_end",
      "column": {
        "default": null,
        "name": "period_end",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "period_start",
      "column": {
        "default": null,
        "name": "period_start",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "proration",
      "column": {
        "default": null,
        "name": "proration",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "quantity",
      "column": {
        "default": null,
        "name": "quantity",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_invoice_id",
      "column": {
        "default": null,
        "name": "stripe_invoice_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_plan_id",
      "column": {
        "default": null,
        "name": "stripe_plan_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_subscription_id",
      "column": {
        "default": null,
        "name": "stripe_subscription_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_subscription_item_id",
      "column": {
        "default": null,
        "name": "stripe_subscription_item_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plan",
      "macro": "belongs_to",
      "resource_name": "StripePlan",
      "through": null
    }
  ],
  "paramKey": "stripe_invoice_item",
  "primaryKey": "id"
}

/** Frontend model for StripeInvoiceItem. */
class StripeInvoiceItem extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  amount() {
    return this.readAttributeUnderscore("amount")
  }

  /** @returns {boolean} */
  hasAmount() {
    const value = this.amount()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  quantity() {
    return this.readAttributeUnderscore("quantity")
  }

  /** @returns {boolean} */
  hasQuantity() {
    const value = this.quantity()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeInvoiceId() {
    return this.readAttributeUnderscore("stripe_invoice_id")
  }

  /** @returns {boolean} */
  hasStripeInvoiceId() {
    const value = this.stripeInvoiceId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripePlanId() {
    return this.readAttributeUnderscore("stripe_plan_id")
  }

  /** @returns {boolean} */
  hasStripePlanId() {
    const value = this.stripePlanId()

    return this._isPresent(value)
  }

  /** @returns {import("./stripe-plan.js").default | null} */
  stripePlan() {
    return this._readBelongsToReflection({reflectionName: "stripe_plan"})
  }

  /** @returns {Promise<import("./stripe-plan.js").default | null>} */
  loadStripePlan() {
    if (!("stripePlanId" in this)) throw new Error("Foreign key method wasn't defined: stripePlanId")

    const id = this.stripePlanId()
    const modelClass = modelClassRequire("StripePlan")
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "stripe_plan", model: this, modelClass},
      {ransack}
    )
  }
}

export default StripeInvoiceItem
